// ResetPasswordGuestForm.jsx
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import HeroSection from "../../components/heroSection/HeroSection";
import heroPhoto from "../../assets/images/photo.jpg";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import "../registerDriverPage/RegisterDriverPage.css";
import Footer from "../footer/Footer";
import { authAPI } from "../../api/apiSystem";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

export default function ResetPasswordGuestPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const initialEmail = queryParams.get("email") || "";
  const initialToken = queryParams.get("token") || "";

  // القيم موجودة في state لكن مش هنظهر الحقول
  const [email] = useState(initialEmail);
  const [token] = useState(initialToken);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  

  useEffect(() => {
    if (token) {
      try {
        localStorage.setItem("token", token);
        localStorage.setItem("userType", 'guest');
      } catch (err) {
        console.warn("Could not save token to localStorage", err);
      }
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !token) {
      setError(t("guestSetPassword.error.emailTokenRequired"));
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(t("guestSetPassword.error.passwordMismatch"));
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await authAPI.guestSetPassword({
        email,
        token,
        password: newPassword,
        password_confirmation: confirmPassword,
      });

      if (res.success) {
        setSuccess(t("guestSetPassword.success"));
        Swal.fire({
          icon: "success",
          title: t("guestSetPassword.success"),
          text: t("guestSetPassword.successMessage") || "",
          confirmButtonColor: "#ffc107",
        });
        try {
          if (authAPI.logout) await authAPI.logout();
        } catch (err) {
          console.warn("logout failed", err);
        } finally {
          localStorage.removeItem("token");
          navigate("/login");
        }
      } else {
        setError(res.message || t("guestSetPassword.error.generic"));
        Swal.fire({
          icon: "error",
          title: t("guestSetPassword.errorTitle") || "Error",
          text: res.message || t("guestSetPassword.error.generic"),
          confirmButtonColor: "#dc3545",
        });
      }
    } catch (err) {
      setError(t("guestSetPassword.error.serverFailure"));
      Swal.fire({
        icon: "error",
        title: t("guestSetPassword.errorTitle") || "Error",
        text: t("guestSetPassword.error.serverFailure"),
        confirmButtonColor: "#dc3545",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleLater = () => {
    navigate("/");
  };

  return (
    <>
      {/* <HeroSection
        backgroundImage={heroPhoto}
        title={t("guestSetPassword.heroSection.title")}
        titleHighlight={t("guestSetPassword.heroSection.titleHighlight")}
        showTopbar={false}
        showNavbar={true}
        features={t("guestSetPassword.heroSection.features", { returnObjects: true })}
        showQuoteForm={false}
        showCTAButton={false}
        customHeight="100%"
      /> */}

      <div className="login-section mt-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="shadow-lg p-4 border-0 register-driver-card">
                <Card.Body>
                  <h4 className="text-center mb-4 text-dark fw-bold">
                    {t("guestSetPassword.title")}
                  </h4>
                  {error && <div className="alert alert-danger text-center">{error}</div>}
                  {success && <div className="alert alert-success text-center">{success}</div>}
                  
                  <Form onSubmit={handleSubmit}>
                    {/* New Password */}
                    <Form.Group controlId="formPassword" className="mb-3">
                      <Form.Label>{t("guestSetPassword.newPasswordLabel")}</Form.Label>
                      <div className="position-relative">
                        <FaLock className="form-icon" />
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder={t("guestSetPassword.newPasswordPlaceholder")}
                          className="ps-5"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          required
                        />
  
                        <span
                          className="password-toggle-icon"
                          onClick={() => setShowPassword(prev => !prev)}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </Form.Group>

                    {/* Confirm Password */}
                    <Form.Group controlId="formConfirmPassword" className="mb-3">
                      <Form.Label>{t("guestSetPassword.confirmPasswordLabel")}</Form.Label>
                      <div className="position-relative">
                        <FaLock className="form-icon" />
                        <Form.Control
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder={t("guestSetPassword.confirmPasswordPlaceholder")}
                          className="ps-5"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
  
                        <span
                          className="password-toggle-icon"
                          onClick={() => setShowConfirmPassword(prev => !prev)}
                        >
                          {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </Form.Group>

                    <Button
                      type="submit"
                      variant="warning"
                      disabled={loading}
                      className="w-100 mt-4 bg-orange-500 text-white"
                    >
                      {loading ? t("guestSetPassword.submitButtonLoading") : t("guestSetPassword.submitButton")}
                    </Button>

                    <Button
                      type="button"
                      variant="secondary"
                      className="w-100 mt-2"
                      onClick={handleLater}
                    >
                      {t("guestSetPassword.laterButton") || "Later"}
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
}
